import React, { Component } from 'react'
import moment from 'moment';
import { Link } from 'react-router';
import {ChiTietDoiTuongThanhTraDialog} from 'modules/dialog';
import TextTruncate from 'react-text-truncate';
import {isEmpty, get} from 'lodash';

export default class RowItemDanhMucTongHopThanhTra extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chiTietDT: false,
      isOpen: false,
    }
  }

  toggleDialog(status) {
    this.state.chiTietDT = status;
    this.setState({...this.state});
  }

  toggleDialogOpen() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  render() {
    let data = this.props.item;
    let { noiDungThanhTra, donViInfo, namThanhTra, keHoachThanhTraInfo, listDoiTuongThanhTra } = this.props.item;
    let getTen = '';
    if (data && data.doiTuongThanhTras && data.doiTuongThanhTras.length > 0 && data.cuocThanhTraNhieuDoiTuong === false) {
      getTen = data.doiTuongThanhTras[0].ten;
    } else if (data && data.listDoiTuongThanhTra && data.listDoiTuongThanhTra.length > 0 && data.cuocThanhTraNhieuDoiTuong === false) {
      getTen = data.listDoiTuongThanhTra[0].ten;
    } else if (data.tenNhieuDoiTuongThanhTra && data.cuocThanhTraNhieuDoiTuong === true) {
      getTen = this.props.item.tenNhieuDoiTuongThanhTra;
    }
    let quyetDinhPheDuyetKTTT = keHoachThanhTraInfo && keHoachThanhTraInfo.quyetDinhPheDuyetKTTT;
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
          <div className="mgbt10">
            <Link className='txt-underline txt-regular' name='abc' onClick={this.toggleDialog.bind(this, true)}>{this.props.item.ten || ''}</Link>
            <ChiTietDoiTuongThanhTraDialog name="chiTietDT" data={this.props.item} open={this.state.chiTietDT} onClose={this.toggleDialog.bind(this, false)} />
          </div>
          <div>
            {`${listDoiTuongThanhTra.length || ''} đối tượng `}
          </div>
        </td>
        <td>
          <Link className='txt-underline text-color-default' to={'/thanh-tra/cuoc-thanh-tra/chi-tiet/' + data.cuocThanhTraId}>
            {
            noiDungThanhTra &&
            <TextTruncate
              line={3}
              truncateText="…"
              text={noiDungThanhTra}/>
            }
          </Link>
        </td>
        <td>
          {donViInfo.ten || ''}
        </td>
        <td>
          {namThanhTra || ''}
        </td>
        <td>
          {quyetDinhPheDuyetKTTT || ''}
        </td>
        <td>
          {!isEmpty(get(data, 'keHoachThanhTraInfo.ngayGuiTTTP')) ? moment(data.keHoachThanhTraInfo.ngayGuiTTTP).format('DD/MM/YYYY') : ''}
        </td>
        <td>{get(data, 'loaiCuoc.value') === 'KIEM_TRA' ? 'Kiểm tra' : 'Thanh tra'}</td>
        <td>
          {get(this.props.item, 'tienDoThanhTraInfo.text') || ''}
        </td>
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra-trung/datatable/RowItemDanhMucTongHopThanhTra.jsx